import { render, staticRenderFns } from "./resumorhagrupamento.vue?vue&type=template&id=5e92ac16&scoped=true&"
import script from "./resumorhagrupamento.vue?vue&type=script&lang=js&"
export * from "./resumorhagrupamento.vue?vue&type=script&lang=js&"
import style0 from "./resumorhagrupamento.vue?vue&type=style&index=0&id=5e92ac16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e92ac16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VIcon})
